import { getAutoBookmark, getBookmarks } from "lib/bookmarks/get-bookmarks";
import { addFreeDraftToMyBooks } from "lib/drafts/add-free-draft-to-my-books";
import { experimentsQueryOptions } from "lib/experiments/use-experiments";
import { getConfig } from "lib/get-config";
import { loadTranslations } from "lib/i18n/config";
import { getQuotes } from "lib/quotes/get-quotes";
import { getToc } from "lib/toc/get-toc";

import { queryClient } from "app/query-client";

export function prefetch() {
  const { art, user, uilang, draftFree } = getConfig();

  if (user) {
    // Бесплатные черновики нужно явно помещать в Мои книги
    if (draftFree) {
      queryClient.prefetchQuery({
        queryKey: ["free-draft", art],
        queryFn: () => addFreeDraftToMyBooks(art),
      });
    }
    queryClient.prefetchQuery({
      queryKey: ["autobookmark", art],
      queryFn: () => getAutoBookmark(art),
    });
    queryClient.prefetchQuery({
      queryKey: ["bookmarks", art],
      queryFn: () => getBookmarks(art),
    });
    queryClient.prefetchQuery({
      queryKey: ["quotes", art],
      queryFn: () => getQuotes(art),
    });
  }
  queryClient.prefetchQuery({
    queryKey: ["toc", art],
    queryFn: () => getToc(),
  });
  queryClient.prefetchQuery(experimentsQueryOptions());
  queryClient.prefetchQuery({
    queryKey: ["translations", uilang],
    queryFn: () => loadTranslations(uilang),
  });
}
